import * as MutationTypes from "../mutation_types"
import { State, AuthHeaders, CasesearchQueryLog } from "../store_types"
import {
  callCasesearchQueryLogAPI,
  callDownloadCasesearchQueryLogAPI,
} from "../../api/casesearch_query_log"
import { AxiosResponseHeaders } from "axios"
import { saveAs } from "file-saver"

const getDefaultState = () => {
  return {
    casesearchQueryLogs: [],
  }
}

const casesearchQueryLogs = {
  state: () => getDefaultState(),

  getters: {
    logs(state: State) {
      return state.casesearchQueryLogs
    },
  },

  actions: {
    fetchCasesearchQueryLogs({
      dispatch,
      commit,
      getters,
    }: {
      dispatch: (actionName: string, result: boolean) => void;
      commit: (
        mutationType: string,
        resultData: AxiosResponseHeaders | Array<CasesearchQueryLog> | boolean
      ) => void;
      getters: { [key: string]: AuthHeaders | number | Date };
    }) {
      return new Promise<void>((resolve, reject) => {
        callCasesearchQueryLogAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedCasesearchQueryLogDate as Date,
          },
          // Success
          (
            headers: AxiosResponseHeaders,
            casesearchQueryLogs: Array<CasesearchQueryLog>
          ) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(
              MutationTypes.ASSIGN_CASESEARCH_QUERY_LOG,
              casesearchQueryLogs
            )
            resolve()
          },
          // Failure
          () => {
            reject()
          }
        )
      })
    },

    downloadCasesearchQueryLogs({
      commit,
      getters,
    }: {
      commit: (mutationType: string, resultData: AxiosResponseHeaders) => void;
      getters: { [key: string]: AuthHeaders | number | Date };
    }) {
      return new Promise<void>((resolve, reject) => {
        callDownloadCasesearchQueryLogAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedCasesearchQueryLogDate as Date,
          },
          // Success
          (headers: AxiosResponseHeaders, csvData: Blob) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            const targetMonth = getters.selectedCasesearchQueryLogDate as Date
            saveAs(
              csvData,
              `みんなの相談検索_検索ワードランキング_${targetMonth.getFullYear()}年${
                targetMonth.getMonth() + 1
              }月.csv`
            )
            resolve()
          },
          // Failure
          () => {
            reject()
          }
        )
      })
    },
  },

  mutations: {
    [MutationTypes.ASSIGN_CASESEARCH_QUERY_LOG](
      state: State,
      casesearchQueryLogs: Array<CasesearchQueryLog>
    ) {
      state.casesearchQueryLogs = casesearchQueryLogs
    },
    [MutationTypes.RESET_CASESEARCH_QUERY_LOG_STATE](state: State) {
      Object.assign(state, getDefaultState())
    },
  },
}

export default casesearchQueryLogs
